/* eslint-disable */
import { formatIntDate, getStoreTimingsForDatesAndStores} from '../util/utilFidaFunctions.ts';


// import { useSelector } from 'react-redux';

//import store from '@/store/';
// import { getStoreCodesByLocations } from '../util/utilFunctions';
import {
  addDays,
  addWeeks,
  differenceInDays
} from "date-fns";
import {
  GetReportingSumDataFidaV2,
  GetKpisPlainDataFidaForDemographics,
  GetReportingSumDataByLocationFidaV2OnlyExport,
  
} from '../api/fida.ts';

import * as XLSX from 'xlsx';
import { any } from 'prop-types';


// All Stores Daily New
function formatResponseAllStoresDailyReport(apiResponse, targetKpiName, lang, storeKeyValuePairs) {
 // apiResponse = sortingByOrder(apiResponse, 'StoreNumber', 'ASC','alldaily');
  const formattedData = {};

  for (const kpi of apiResponse) {
    const storeCode = kpi._id?.split('_')[1];
    const date = formatIntDate(kpi._id?.split('_')[0]);
    const sales = kpi[targetKpiName];

    if (!formattedData[storeCode]) {
      const storeName = GetStoreNameByCode(storeCode,storeKeyValuePairs);
      formattedData[storeCode] = {
        storeName: storeName,
      };
    }

    formattedData[storeCode][date] = sales;
  }

  // Sort dates in ascending order
  for (const storeCode of Object.keys(formattedData)) {
    const storeData = formattedData[storeCode];
    const sortedDates = Object.keys(storeData).filter(key => key !== "storeName").sort();
    storeData.sortedDates = sortedDates;
  }

  const result:any = [];
  var headerRow:any = [];

  // Create the header row
  if(!Object.keys(formattedData)[0])
  {
    if (lang == 'en') {
      headerRow = ["Store Code", "Store Name"];
    } else {
      headerRow = ["店コード", "店名"];
    }
  }
  else
  {
    if (lang == 'en') {
      headerRow = ["Store Code", "Store Name", ...formattedData[Object.keys(formattedData)[0]].sortedDates];
    } else {
      headerRow = ["店コード", "店名", ...formattedData[Object.keys(formattedData)[0]].sortedDates];
    }
  }

  result.push(headerRow.join(', '));

  for (const storeCode of Object.keys(formattedData)) {
    const storeData = formattedData[storeCode];
    const row = [storeCode, storeData.storeName];
    for (const date of storeData.sortedDates) {
      row.push(storeData[date]);
    }
    result.push(row.join(', '));
  }
  return result.join("\n");
}

function sortByDate(data) {
  return data.sort((a, b) => {
      // Extract dates from _id field
      const dateA = a._id?.split('_')[0];
      const dateB = b._id?.split('_')[0];


      // Compare dates
      return dateA- dateB;
  });
}
//Daily Report New
function formatResponseDailyReport(apiResponse: any, lang: string, storeKeyValuePairs: any) {
  //order = "desc";
  console.log('formatResponseDailyReport',apiResponse)
  apiResponse = sortByDate(apiResponse);//sortingByOrder(apiResponse, orderKey, order, 'daily');
  const formattedData = {};

  // Process the API response data

  apiResponse.forEach(item => {
    const storeCode = item._id?.split('_')[1];
    const date = formatIntDate(item._id?.split('_')[0]);
    const time = date;//date.toString(); // Format hour as "HH:00"

    // Create a key for the storeCode if it doesn't exist in the formatted data
    if (!formattedData[storeCode]) {
      formattedData[storeCode] = [];
    }

    // Extract and format the KPIs dynamically
    const kpis = Object.keys(item)
      .filter(key => key !== "_id") // Exclude "_id" field
      .map(key => item[key]?item[key].toLocaleString():0); // Format KPI values as strings with commas

    formattedData[storeCode].push([time, ...kpis]);
  });
  // Extract the list of unique KPIs dynamically
  const allKPIs = [...new Set(apiResponse.flatMap(item => Object.keys(item)).filter(key => key !== "_id"))];

  // Find the KPI with the most data entries
    allKPIs.reduce((maxKpi: any, kpiName: any) => {
    const kpiDataArr = apiResponse.map(item => item[kpiName]);
    const nonUndefinedDataCount = kpiDataArr.filter(data => data !== undefined).length;
    const maxKpiDataArr = apiResponse.map(item => item[maxKpi]);
    const maxKpiDataCount = maxKpiDataArr.filter(data => data !== undefined).length;

    return nonUndefinedDataCount > maxKpiDataCount ? kpiName : maxKpi;
  }, allKPIs[0]);

  const result: string[] = [];

  if (lang === 'en') {
    result.push(`Date,Store Name,Store Code, ${allKPIs.join(", ")}`);//Date	Store Name	Store Code	Sales	Traffic

  } else {
    result.push(`Date,店名,店コード, ${allKPIs.join(", ")}`);
  }



  apiResponse.forEach(item => {
    const storeCode = item._id?.split('_')[1];
    const date = formatIntDate(item._id?.split('_')[0]);
    const storeName = GetStoreNameByCode(storeCode,storeKeyValuePairs);
    const kpiValues = allKPIs.map((kpi: any) => (item[kpi] ? item[kpi] : 0));

//    const kpiValues = allKPIs.map(kpi => (item[kpi] ? item[kpi] : 0));
    result.push(` ${date},${storeName},${storeCode},${kpiValues.join(", ")}`);
  });


  var kpiTotals = {};
  allKPIs.forEach((kpi: any) => {
    const total = apiResponse.reduce((sum, item) => sum + (item[kpi] ? Number(item[kpi]) : 0), 0);
    kpiTotals[kpi] = total;
  });
  const count = apiResponse.length; // Replace with your desired count
  kpiTotals = applyCount(kpiTotals, count);
  // Add the totals row to the result
  const totalsRow = ['', '','', ...allKPIs.map((kpi: any) => kpiTotals[kpi])];
  result.push(totalsRow.join(', '));

  return result.join("\n");
}

//Hourly Report New
function formatResponseHourlyKpiReport(apiResponse: any, lang: string, orderKey, order) {
  apiResponse = sortingByOrder(apiResponse, orderKey, order,'hourly');


  const formattedData = {};

  // Process the API response data
  apiResponse.forEach(item => {
    const storeCode = item._id?.split('_')[1];
    const hour = item._id?.split('_')[0];
    const time = `${hour.toString().padStart(2, '0')}:00`; // Format hour as "HH:00"

    // Create a key for the storeCode if it doesn't exist in the formatted data
    if (!formattedData[storeCode]) {
      formattedData[storeCode] = [];
    }
    // Extract and format the KPIs dynamically
    const kpis = Object.keys(item)
      .filter(key => key !== "_id") // Exclude "_id" field
      .map(key => item[key]?item[key].toLocaleString():0); // Format KPI values as strings with commas

    formattedData[storeCode].push([time, ...kpis]);
  });

  // Extract the list of unique KPIs dynamically
  const allKPIs = [...new Set(apiResponse.flatMap(item => Object.keys(item)).filter(key => key !== "_id"))];

  // Find the KPI with the most data entries
  allKPIs.reduce((maxKpi: any, kpiName: any) => {
    const kpiDataArr = apiResponse.map(item => item[kpiName]);
    const nonUndefinedDataCount = kpiDataArr.filter(data => data !== undefined).length;
    const maxKpiDataArr = apiResponse.map(item => item[maxKpi]);
    const maxKpiDataCount = maxKpiDataArr.filter(data => data !== undefined).length;

    return nonUndefinedDataCount > maxKpiDataCount ? kpiName : maxKpi;
  }, allKPIs[0]);

  const result: string[] = [];
  if (lang === 'en') {
    result.push(`Store Code, Hour, ${allKPIs.join(", ")}`);
  } else {
    result.push(`店コード, 時間, ${allKPIs.join(", ")}`);
  }

  apiResponse.forEach(item => {
    const storeCode = item._id?.split('_')[1];
    const hour = item._id?.split('_')[0];
    const kpiValues = allKPIs.map((kpi: any) => (item[kpi] ? item[kpi] : 0));
    result.push(` ${storeCode},${hour.toString().padStart(2, '0')}:00,  ${kpiValues.join(", ")}`);
  });


  var kpiTotals = {};
  allKPIs.forEach((kpi: any) => {
    const total = apiResponse.reduce((sum, item) => sum + (item[kpi] ? Number(item[kpi]) : 0), 0);
    kpiTotals[kpi] = total;
  });

  const count = apiResponse.length; // Replace with your desired count
  kpiTotals = applyCount(kpiTotals, count);
  // Add the totals row to the result
  const totalsRow = ['', '', ...allKPIs.map((kpi: any) => kpiTotals[kpi])];
  result.push(totalsRow.join(', '));

  return result.join("\n");
}
function applyCount(response, count) {
  const keysToSum = ["cn", "ap", "upt", "rov", "aip", "spt", "tpt", "sl", "sh", "cs", "se", "cr", "dw", "st", "tra"];

  const updatedResponse = { ...response };

  keysToSum.forEach(key => {
    if (response[key] !== undefined && typeof response[key] === "number") {
      if(key == "cn" || key == "upt" || key == "tpt" || key == "cr")
        updatedResponse[key] = (response[key] / count).toFixed(2);
      else
        updatedResponse[key] = Math.round(response[key] / count);
    }
  });

  return updatedResponse;
}

// Houlry Report By Store
function formatResponseHourofDayKpiReport(apiResponse: any): string {
  const processedData:any = [];

  apiResponse.forEach(item => {
    const { ...kpiData } = item;
    const _id2 = item._id?.split('_');
    const dateDt = formatIntDate(_id2[0]);
    const hour = _id2[1];
    const storeCode = _id2[3];
  //delete apiResponse[item._id]._id;
    if(kpiData['trf'])
    {
      //trf =
      var trafficSum =0;
      console.log('kpiData.trf',kpiData.trf);
      for(const trff in kpiData.trf)
      {
        debugger;
       // trafficSum += kpiData.trf[trff].trf;
      //  trafficSum += kpiData.trf[trff].trf?kpiData.trf[trff].trf:kpiData.trf[trff].out;
      trafficSum += kpiData.trf[trff].trf ? kpiData.trf[trff].trf 
      : kpiData.trf[trff].out ? kpiData.trf[trff].out 
      : 0;

    }
      kpiData.trf = trafficSum;
    }

    const obj = {
      storeCode:storeCode,
      date: dateDt,
      hour: hour+':00',
      ...kpiData
    }
    processedData.push(obj);
  });


    //const kpiValue = Object.keys(kpiData).length > 0 ? kpiData[kpiType].countValue : undefined;

  // Sort the processed data by Store Code, Date, and Hour
  processedData.sort((a:any, b:any) => {
    if (a.storeCode !== b.storeCode) {
      return a.storeCode.localeCompare(b.storeCode);
    }
    if (a.date !== b.date) {
      return a.date.localeCompare(b.date);
    }
    return a.hour.localeCompare(b.hour);
  });

  const obj2 = {...apiResponse[0]};
  delete obj2._id;
  console.log('obj--',obj2);
  // getKpiTitle

  const kpiTypes = Object.keys(obj2);
  var headerRow:any = [];
  if(lang == 'en')
  {
    headerRow = ['Store Code', 'Date', 'Hour', ...kpiTypes];
  }
  else
  {
    headerRow = ['店コード', '日付', '時間', ...kpiTypes];
  }
  const result = processedData.map(data => {
    const rowData = [data.storeCode, data.date, data.hour];
    // kpiTypes.forEach((kpiType: any) => {
    //   rowData.push(data[kpiType] !== undefined ? data[kpiType] : '0');
    // });

    kpiTypes.forEach((kpiType: any) => {
      rowData.push(data[kpiType] !== undefined ? String(data[kpiType]) : '0');
    });


    return rowData;
  });

  result.unshift(headerRow);

  return result.map(row => row.join(', ')).join('\n');
}

// common functions
var lang;
export async function APIExport(exportRequestBody: any, t:any,storesData:any) {
  lang = exportRequestBody.lang;
  var reportType = '';
  var reportType2 = '';
  var api1=0;

  if(exportRequestBody.reportType == 'daily')
  {
    reportType = 'daily';
    reportType2 = 'daily';
    api1 = 1;
  }
  else if(exportRequestBody.reportType == 'AllStoresDaily')
  {
    reportType = 'daily';
    reportType2 = 'AllStoresDaily';
    api1 = 1;
  }
  else if(exportRequestBody.reportType == 'hourofdaykpi'){
    reportType = 'hourly';
    api1 = 0;
    reportType2 = 'hourofdaykpi';
  }
  else if(exportRequestBody.reportType == 'hourly'){
    reportType = 'hourly';
    api1 = 1;
    reportType2 = 'hourly';
  }
  else if(exportRequestBody.reportType == 'demographics'){
    reportType = 'demographics';
    reportType2 = 'demographics';
    api1 = 0;
  }
  else if(exportRequestBody.reportType == 'detailed')
  {
    reportType = 'all';///from all to daily
    reportType2 = 'detailed';
    api1 = 2;
  }
 
  else {
    alert('Report Type not defined');
    return;
  }

  let cleanedStoreCodes4 = exportRequestBody.storeCodes?.split(',').filter(code => code.trim() !== '').join(',');

  const requestBody = {
    "startDate": exportRequestBody.startDate,
    "endDate": exportRequestBody.endDate,
    "frequency": reportType,//daily
    "storeCodes": cleanedStoreCodes4?.split(","),
    "kpiTypes": exportRequestBody.kpis?.split(","),
    "reportType": exportRequestBody.reportType
  }
  var requestBody2:any = {
    "startDate": exportRequestBody.startDate,
    "endDate": exportRequestBody.endDate,
    "frequency": reportType,//daily
    "storeCodes": cleanedStoreCodes4?.split(","),
    "kpiTypes": exportRequestBody.kpis?.split(","),
    "compareStartDate":exportRequestBody.compareStartDate,
    "compareEndDate": exportRequestBody.compareEndDate,
    "reportType": exportRequestBody.reportType
  }

  const dateForName = exportRequestBody.startDate+'_'+exportRequestBody.endDate;

  if(api1 == 1)
  {
    const response = await GetReportingSumDataByLocationFidaV2OnlyExport(requestBody);
    console.log('response',response)
    await exportToExcel(response.kpis,reportType2,dateForName, exportRequestBody, t,cleanedStoreCodes4,storesData);
    return response;
  }
  else if(api1 == 2 )
  {
    requestBody2.isReport = 1;

    if(exportRequestBody.reportType == 'summary')
    {

      var startDate3 = new Date(exportRequestBody.startDate);
      var endDate3 = new Date(exportRequestBody.endDate);

      // Subtract 7 days from the startDate
      startDate3.setDate(startDate3.getDate() - 7);
      endDate3.setDate(endDate3.getDate() - 7);
      //endDate3.toISOString().slice(0, 10),
      if(requestBody2.compareStartDate != requestBody2.compareEndDate)
      {
        requestBody2.compareStartDate = startDate3.toISOString().slice(0, 10);
        requestBody2.compareEndDate = endDate3.toISOString().slice(0, 10);
      }
    }
    var response1:any;
    var startDate = new Date(requestBody2.startDate);
    var endDate = new Date(requestBody2.endDate);
    //var timeDifference = endDate.getTime() - startDate.getTime();
    // var daysDifference = timeDifference / (1000 * 60 * 60 * 24);
    // const compareStartDate2 = requestBody2.compareStartDate;
    // const compareEndDate2 = requestBody2.compareEndDate;


    if(exportRequestBody.reportType == 'summary')
    {
      const previousPeriod = getPreviousPeriod(startDate, endDate);

      requestBody2.compareStartDate = previousPeriod.previousStartDate;
      requestBody2.compareEndDate = previousPeriod.previousEndDate;

      response1 = await GetReportingSumDataByLocationFidaV2OnlyExport(requestBody2);
    }
    else
    {
      const previousPeriod = getPreviousPeriod(startDate, endDate);

      requestBody2.compareStartDate = previousPeriod.previousStartDate;
      requestBody2.compareEndDate = previousPeriod.previousEndDate;
      response1 = await GetReportingSumDataByLocationFidaV2OnlyExport(requestBody2);
    }

    var response2: any;

    {
      if(response1)
      {
        if(response1.compare)
        {
          response1.kpisLastWeek = [...response1.compare]
        }
      }

    }

    await exportToExcel(response1,reportType2,dateForName, exportRequestBody,t,cleanedStoreCodes4,storesData);

    return response2;
  }
  else//for demographic
  {
    var response: any;
    if(exportRequestBody.reportType == 'demographics')
    {
      //  have to check this  delete requestBody.frequency;
      requestBody.kpiTypes = 'dm'?.split(",");
      response = await GetKpisPlainDataFidaForDemographics(requestBody);

    }
    else
    {

      response = await GetReportingSumDataFidaV2(requestBody);
    }

    await exportToExcel(response.kpis,reportType2,dateForName, exportRequestBody,t,cleanedStoreCodes4,storesData);
    return response;
  }
}

function getPreviousYearSameWeekDates(startDate, endDate) {

  let st = addDays(
    new Date(startDate),
    -364
  );
  let et = addDays(new Date(endDate), -364);
  //this.setComparedPeriod(st, et)

  return { prevYearStart: formatDate(st), prevYearEnd: formatDate(et) };
}

//Demographic report final
function generateTimestamps(date, storeCode, openingTime, closingTime) {

  const timestamps:any = [];
  for (let i = openingTime; i <= closingTime; i++) {
      const timestamp = new Date(`${date}T${i.toString().padStart(2, '0')}:00:00.000Z`);
      timestamps.push({
          "kpiType": "demographics",
          "storeCode": storeCode,
          "demographics": {
            "ageGroup": {
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
          },
        },
          "startTimestamp": timestamp.toISOString()
      });
  }
  return timestamps;
}

// function getPreviousYearSameWeekDates(startDate, endDate) {


//   const start:any = new Date(startDate);
//   var end:any = new Date(endDate);
//   // Calculate the day of the week for the start date (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
//   const inputDayOfWeek = start.getDay();

//   // Subtract a year from both start and end dates
//   start.setFullYear(start.getFullYear() - 1);
//   end.setFullYear(end.getFullYear() - 1);

//   // Find the first date in the previous year with the same day of the week
//   while (start.getDay() !== inputDayOfWeek) {
//     start.setDate(start.getDate() + 1);
//   }

//   // Calculate the end date based on the start date and the duration of the input period

//   let diffInDays = (end - start) / (1000 * 60 * 60 * 24);
//   diffInDays = diffInDays+1;
//   var endStartDate:any = new Date(start);

//   endStartDate.setDate(endStartDate.getDate() + diffInDays);
//   end = endStartDate;

//   // Format the resulting dates as "yyyy-MM-dd"
//   const prevYearStart = start.toISOString().slice(0, 10);
//   const prevYearEnd = end.toISOString().slice(0, 10);

//   return { prevYearStart, prevYearEnd };
// }

function formatResponseDemographics(apiResponse: any, lang,t:any, storeCodeList,storesData:any): string {
  debugger
  apiResponse = apiResponse.map(item => {
    const timestampParts = item._id?.split('_');
    const storeCode = timestampParts[3];
    const date = timestampParts[0].substring(0, 4) + '-' + timestampParts[0].substring(4, 6) + '-' + timestampParts[0].substring(6, 8);
    const hour = timestampParts[1];
    const startTimestamp = date + 'T' + hour + ':00:00.000Z';
  
    const demographics:any = {};
    demographics.ageGroup = { ...item.dm };

    return {
        kpiType: "demographics",
        storeCode,
        demographics,
        startTimestamp
    };
});

  const result: string[] = [];


  var ageGroups = ["1", "2", "3", "4", "5", "6", "7", "8"];
  //var ageGroups = ["a", "b", "c", "d", "e", "f", "g", "h"];
  var ageGroupLabels:any = [];
    {
      ageGroupLabels = [
        t('male_child_report'),
        t('male_young_report'),
        t('male_adult_report'),
        t('male_senior_report'),

        t('female_child_report'),
        t('female_young_report'),
        t('female_adult_report'),
        t('female_senior_report')
      ];
    }
  // }
  // else
  // {
  //   ageGroupLabels = [
  //     "男性-10代", "男性-20代", "男性-30/40代", "男性-50代以上",
  //     "女性-10代", "女性-20代", "女性-30/40代", "女性-50代以上"
  //   ];
  // }

  const groupedData: Record<string, Record<string, number[]>> = {};

  //const uniqueStoreCodes = [...new Set(apiResponse.map(entry => entry.storeCode))];
  const uniqueDates = [...new Set(apiResponse.map(entry => entry.startTimestamp?.split('T')[0]))];

  let storeCodes = storeCodeList?.split(',');//storeState.store.storesCodeNameList.map(store => store.storeCode);
  const res:any = getStoreTimingsForDatesAndStores(uniqueDates, storeCodes, storesData);

  for (const [date, storeData] of Object.entries(res)) {

    for (const [storeCode, timings] of Object.entries(storeData)) {

        const existingTimestamps = apiResponse.filter(item => item.storeCode === storeCode && item.startTimestamp.startsWith(date));
        if (existingTimestamps.length < timings.closingTime - timings.openingTime + 1) {
            const missingHours = [];
            for (let hour = timings.openingTime; hour <= timings.closingTime; hour++) {
                const timestampExists = existingTimestamps.some(item => parseInt(item.startTimestamp.slice(-23, -21)) === hour);
                if (!timestampExists) {
                    missingHours.push(hour);
                }
            }

            const missingTimestamps = generateTimestamps(date, storeCode, missingHours[0], missingHours[missingHours.length - 1]);
            apiResponse = apiResponse.concat(missingTimestamps);
        }
    }
}

  apiResponse.forEach(entry => {
    const startTimestamp = new Date(entry.startTimestamp);
    const date = startTimestamp.toISOString().substring(0, 10);
    const hour = startTimestamp.getUTCHours().toString().padStart(2, "0") + ":00";

    if (!groupedData[date]) {
      groupedData[date] = {};
    }

    if (!groupedData[date][hour]) {
      groupedData[date][hour] = new Array(ageGroups.length).fill(0);
    }

    ageGroups.forEach((ageGroup, index) => {
      if (entry.demographics.ageGroup[ageGroup]) {
        groupedData[date][hour][index] += entry.demographics.ageGroup[ageGroup];
      }
    });
  });
  // Create an array of date-hour combinations and sort them
  const dateHourCombinations = Object.keys(groupedData).flatMap(date =>
    Object.keys(groupedData[date]).map(hour => ({ date, hour }))
  );
  dateHourCombinations.sort((a, b) => {
    const dateComparison = a.date.localeCompare(b.date);
    if (dateComparison !== 0) {
      return dateComparison;
    }
    return a.hour.localeCompare(b.hour);
  });

  // Generate header based on available age groups
  var header:any = [];
  if(lang == 'en')
  {
    header = ["Date", "Hour", ...ageGroupLabels.slice(0, ageGroups.length)];
  }
  else
  {
    header = ["日付", "時間", ...ageGroupLabels.slice(0, ageGroups.length)];
  }
  result.push(header.join(","));

  for (const { date, hour } of dateHourCombinations) {
    const total = groupedData[date][hour].reduce((sum, value) => sum + value, 0);
    // const percentages = groupedData[date][hour].map(value => ((value / total)).toFixed(3));
    // const percentages:any = groupedData[date][hour].map(
    //   value =>
    //   ((value / total)*100).toFixed(2)
    //   );
    const percentages = groupedData[date][hour].map(value => {
      const percentage = (total !== 0 || value !== 0) ? ((value / total) * 100).toFixed(2) : 0;
      return Number(percentage); // Convert back to number
  });

    const percentagesAfter:any = percentages.map(
      v => (Math.floor(((v?v:0) / 100)*1000)/1000).toString()
    );
    //(Math.floor(((percentages) / 100)*1000)/1000).toString();


    result.push(`${date},${hour},${percentagesAfter.join(",")}`);
  }

  return result.join("\n");
}
export async function exportToExcel(apiResponse: any, reportType: string, dateForName: string, exportRequestBody, t:any,storeCodes: string, storesData:any): Promise<void> {

  const storeKeyValuePairs = storesData.reduce((acc, store) => {
    acc[store.storeCode] = store.name;
    return acc;
  }, {});
  console.log('storeKeyValuePairs',storeKeyValuePairs);

  var kpis = exportRequestBody.kpis;
  var orderKey = exportRequestBody.orderKey;//orderKey: "sales", order:"ASC"
  var order = exportRequestBody.order;
  var formattedResult;
  var fileName;

  if (reportType === 'hourly') {
    if(lang == 'en')
      fileName = 'Hourly Total_'+dateForName;
    else
      fileName = '時間毎レポート_'+dateForName;
    formattedResult = formatResponseHourlyKpiReport(apiResponse,lang, orderKey, order);
  }

  else if (reportType === 'daily') {
    if(lang == 'en')
      fileName = 'Daily_'+dateForName;
    else
      fileName = '日毎レポート_'+dateForName;

    formattedResult = formatResponseDailyReport(apiResponse,lang,storeKeyValuePairs);
  }

  else if (reportType === 'AllStoresDaily') {

    const kpiTitle = t(kpis);
    if(lang == 'en')//kpis
      fileName = 'All Stores Daily_'+kpiTitle+'_'+dateForName;//'All Stores Daily_Sales_'+dateForName;
    else
      fileName = '全店日毎レポート_'+kpiTitle+'_'+dateForName;

    formattedResult = formatResponseAllStoresDailyReport(apiResponse, kpis, lang,storeKeyValuePairs);
  }

  else if (reportType === 'demographics') {
    if(lang == 'en')
      fileName = 'Demographics_'+dateForName;//lang
    else
      fileName = '来店者性別分析_'+dateForName;//lang
    formattedResult = formatResponseDemographics(apiResponse, lang, t,storeCodes,storesData);
  }

  else if (reportType === 'hourofdaykpi') {
    if(lang == 'en')
      fileName = 'Hourly By Store & day_'+dateForName;
    else
      fileName = '店舗別時間毎レポート_'+dateForName;

    formattedResult = formatResponseHourofDayKpiReport(apiResponse);

  }

  else {
    alert('No record found');
  }


  const rows = formattedResult?.split('\n').map((row) => row?.split(','));
  const newHeaderNames = rows[0].map((cell) => {
    return t[cell.trim()] || cell;
  });
 
  var updatedRows;
  if (reportType === 'detailed' && (orderKey.toUpperCase() == 'REGION' || orderKey.toUpperCase() == 'DISTRICT'
     || orderKey.toUpperCase() == 'PEERGROUPS1' || orderKey.toUpperCase() == 'PEERGROUPS2' || orderKey.toUpperCase() == 'AREAMANAGERS'
     || orderKey.toUpperCase() == 'STORE' || orderKey.toUpperCase() == 'SV')) {

    var columnToSortIndex = 0;
    if(orderKey.toUpperCase() == 'STORE') {columnToSortIndex = 1;}
    else if(orderKey.toUpperCase() == 'DISTRICT') {columnToSortIndex = 2;}
    else if(orderKey.toUpperCase() == 'REGION') {columnToSortIndex = 3;}
    else if(orderKey.toUpperCase() == 'AREAMANAGERS') {columnToSortIndex = 4;}
    else if(orderKey.toUpperCase() == 'SV') {columnToSortIndex = 4;}//BOTH IDS WILL REMAIN SAME
    else if(orderKey.toUpperCase() == 'PEERGROUPS1') {columnToSortIndex = 5;}
    else if(orderKey.toUpperCase() == 'PEERGROUPS2') {columnToSortIndex = 6;}

    // const columnNameToSort = 'Store Name'; // or 'Area Manager'
    //const columnToSortIndex = rows[1].indexOf(columnNameToSort);

    //  updatedRows = [newHeaderNames, ...rows.slice(1)];

updatedRows = [...rows];
    updatedRows.sort((a, b) => {
      if (a === rows[0]) return -1;
      if (b === rows[0]) return 1;
      if (a === rows[1]) return -1;
      if (b === rows[1]) return 1;

      const valueA = a[columnToSortIndex].trim();
      const valueB = b[columnToSortIndex].trim();

      const comparison = valueA.localeCompare(valueB); // or numA - numB for numeric sorting

      return order.toUpperCase() === 'ASC' ? comparison : -comparison;

    });
 //   updatedRows.splice(1, 0, rows[1]);
 updatedRows = [newHeaderNames, ...updatedRows.slice(1)];
  }
  else
  updatedRows = [newHeaderNames, ...rows.slice(1)];





  const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
    updatedRows.map((row) =>
      row.map((cell, columnIndex) => {

        const trimmedCell = cell.trim();
        var columnIndexVal = 1;
        if (reportType === 'summary')
        {
          columnIndexVal = 0;
        }
//
if(reportType === 'daily')
{
  columnIndexVal = 2;
}
        if(columnIndex > columnIndexVal && !isNaN(Number(trimmedCell)))
        {
          if(Number(trimmedCell).toString().includes('.'))
          {
            if(reportType === 'daily' || reportType === 'hourly' || reportType === 'AllStoresDaily' ){
              return {
                t: 'n',
                v: trimmedCell,
                w: trimmedCell.toLocaleString('en-US', { maximumFractionDigits: 3 }),
                z: '#,##0.00'
              };
            }
            else
            {
              return {
                t: 'n',
                v: trimmedCell,
                w: trimmedCell.toLocaleString('en-US', { maximumFractionDigits: 3 }),
                z: '#,##0.000'
              };
            }
          }
          else
          return {
            t: 'n',
            v: trimmedCell,
            w: trimmedCell.toLocaleString('en-US', { maximumFractionDigits: 0 }),
            z: '#,##0'
          };
        }
        else
        {
          return {
            t: 's', // Treat all cells as strings
            v: trimmedCell,
          };
        }

      })
    )
  );

  const totalColumns = rows.length > 0 ? rows[0].length : 0;
  const columnWidths = Array.from({ length: totalColumns }, () => ({ wch: 13 }));
  worksheet['!cols'] = columnWidths;

  const workbook: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');


  const excelBuffer = XLSX.write(workbook, { type: 'array', bookType: 'xlsx' });
  const excelData = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const excelUrl = URL.createObjectURL(excelData);

  // Create a link element to trigger the download
  const link = document.createElement('a');
  link.href = excelUrl;
  link.download = fileName+'.xlsx';
  link.click();
}

export function GetStoreNameByCode(storeCode:string,storeKeyValuePairs:any)
{
  console.log('storeKeyValuePairs[storeCode]',storeKeyValuePairs[storeCode]);
  storeCode = storeKeyValuePairs[storeCode];

  return storeCode;
}

function getPreviousPeriod(startDate, endDate) {
// if (this.dateOptionsComparedModel.value === "PREVIOUS_PERIOD")
  const diffDays = differenceInDays(
    startDate,
    endDate
  );
  const diffDaysPositive = diffDays < 0 ? (diffDays - 1) * -1 : diffDays + 1;
  // const weeks = Math.ceil((diffDaysPositive / 7).toFixed(2));
  const weeks = Math.ceil(Number((diffDaysPositive / 7).toFixed(2)));
 var previousStartDate = addWeeks(startDate, -weeks);
  var previousEndDate = addWeeks(endDate, -weeks);
  return {
        previousStartDate: formatDate(previousStartDate),
        previousEndDate: formatDate(previousEndDate)
      };
}

function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function sortingByOrder(apiResponse, orderKey, order, page)
{
  if (orderKey == 'StoreNumber')
    orderKey = 'storeCode';

  if (orderKey && order) {
    if (!apiResponse[0] || !apiResponse[0][orderKey]) {
      orderKey = 'storeCode';
    }

    if (orderKey === 'storeCode') {
      apiResponse.sort((a, b) => {

        var aStoreCode;
        var bStoreCode;

        var aOtherCode;
        var bOtherCode;
        if(page == 'hourly')
        {
          aStoreCode = Number(a._id?.split('_')[1]);
          bStoreCode = Number(b._id?.split('_')[1]);

          aOtherCode = Number(a._id?.split('_')[0]);
          bOtherCode = Number(b._id?.split('_')[0]);

          if (order === 'ASC') {
            // First, sort by the second part of the _id
            if (aStoreCode !== bStoreCode) {
              return aStoreCode - bStoreCode;
            }
            // If the second part is the same, then sort by the first part of the _id
            return aOtherCode - bOtherCode;
          } else {
            // Reverse order: First, sort by the second part of the _id
            if (aStoreCode !== bStoreCode) {
              return bStoreCode - aStoreCode;
            }
            // If the second part is the same, then sort by the first part of the _id
            return bOtherCode - aOtherCode;
          }
        }
        else if(page == 'alldaily')
        {
          aStoreCode = Number(a._id?.split('_')[1]);
          bStoreCode = Number(b._id?.split('_')[1]);

            if (order === 'ASC') {
              return aStoreCode - bStoreCode;
            } else {
              return bStoreCode - aStoreCode;
            }
        }
        else
        {
          aOtherCode = Number(a._id?.split('_')[0]);
          bOtherCode = Number(b._id?.split('_')[0]);

          aStoreCode = Number(a._id?.split('_')[1]);
          bStoreCode = Number(b._id?.split('_')[1]);

          if (order === 'ASC') {
            // First, sort by the second part of the _id
            // if (aStoreCode !== bStoreCode) {
            //   return aStoreCode - bStoreCode;
            // }

            if (aOtherCode !== aOtherCode) {
              return aOtherCode - aOtherCode;
            }
            // If the second part is the same, then sort by the first part of the _id
            return aStoreCode - bStoreCode;//aOtherCode - aOtherCode;
          } else {
            // Reverse order: First, sort by the second part of the _id
            if (aOtherCode !== bOtherCode) {
              return bOtherCode - aOtherCode;
            }
            // If the second part is the same, then sort by the first part of the _id
            return bStoreCode - aStoreCode;//bOtherCode - aOtherCode;
          }
        }


      });

      // if(page == 'hourly')
      // {

      // }
    }

else
    apiResponse.sort((a, b) => {
      if (order === "ASC") {
        if (a[orderKey] < b[orderKey]) return -1;
        if (a[orderKey] > b[orderKey]) return 1;
        return 0;
      } else {
        if (a[orderKey] > b[orderKey]) return -1;
        if (a[orderKey] < b[orderKey]) return 1;
        return 0;
      }
    });
  }

  return apiResponse;
}
